import React from 'react';
import { string, shape } from 'prop-types';

const Image = ({
  source,
  ...props
}) => source && (
  <picture {...props}>
    <source srcSet={source.main} type="image/webp" />
    <source srcSet={source.fall} type="image/png" />
    <img src={source.main} alt="we app" {...props} />
  </picture>
);

Image.propTypes = {
  source: shape({
    main: string,
    fall: string,
  }).isRequired,
};

export default Image;
